export const registerEnLocale = {
  'registerForm.validation.email.required': 'Email is required',
  'registerForm.validation.email.invalid': 'Email is invalid',
  'registerForm.validation.name.required': 'Name is required',
  'registerForm.validation.lastname.required': 'Last name is required',
  'registerForm.validation.phone.required': 'Phone is required',
  'registerForm.validation.password.min':
    'Password must be at least 6 characters',
  'registerForm.validation.passwordConfirmation.match':
    'Passwords do not match',
  'registerForm.submit': 'Register',
  'registerForm.title': 'Register',
  'registerForm.or': 'Or register with',
  'registerForm.account': 'Already have an account?',
  'registerForm.login': 'Log in',

  'registerForm.email.placeholder': 'Email',
  'registerForm.name.placeholder': 'Name',
  'registerForm.lastname.placeholder': 'Last name',
  'registerForm.phone.placeholder': 'Phone',
  'registerForm.password.placeholder': 'Password',
  'registerForm.passwordConfirmation.placeholder': 'Password confirmation',
  'registerForm.documentType.label': 'Document type',
  'registerForm.documentNumber.label': 'Document number',
  'registerForm.documentNumber.required': 'Document number is required',
  'registerForm.passport': 'Passport',

  'registerForm.loading': 'Registering...',
  'registerForm.success': 'Welcome!',

  'registerForm.error': 'An error occurred',
} as const;

export const registerEsLocale = {
  'registerForm.validation.email.required': 'El correo es requerido',
  'registerForm.validation.email.invalid': 'El correo no es válido',
  'registerForm.validation.name.required': 'El nombre es requerido',
  'registerForm.validation.lastname.required': 'El apellido es requerido',
  'registerForm.validation.phone.required': 'El teléfono es requerido',
  'registerForm.validation.password.min':
    'La contraseña debe tener al menos 6 caracteres',
  'registerForm.validation.passwordConfirmation.match':
    'Las contraseñas no coinciden',
  'registerForm.submit': 'Registrarme',
  'registerForm.title': 'Registrarme',
  'registerForm.or': 'O regístrate con',
  'registerForm.account': '¿Ya tienes una cuenta?',
  'registerForm.login': 'Iniciar sesión',

  'registerForm.email.placeholder': 'Correo',
  'registerForm.name.placeholder': 'Nombre',
  'registerForm.lastname.placeholder': 'Apellido',
  'registerForm.phone.placeholder': 'Teléfono',
  'registerForm.password.placeholder': 'Contraseña',
  'registerForm.passwordConfirmation.placeholder': 'Confirmar contraseña',
  'registerForm.documentType.label': 'Tipo de documento',
  'registerForm.documentNumber.label': 'Número de documento',
  'registerForm.documentNumber.required': 'El número de documento es requerido',
  'registerForm.passport': 'Pasaporte',

  'registerForm.loading': 'Registrando...',
  'registerForm.success': '¡Bienvenido!',

  'registerForm.error': 'Ocurrió un error',
} as const;
